import React from 'react';
import { PriceProgressBar } from '@/features/line-items/price-progress-bar';
import { MarginIndicator } from '@/features/line-items/margin-indicator';
import { ProposalAttributes } from '@/features/proposals/proposal-input';
import { useProposalContext } from '@/features/proposals/proposal-context';

export function ProposalTopSection() {
  const { proposal, lineItems } = useProposalContext();
  const allocated = lineItems.map(l => l.price).reduce((a, b) => a + b, 0);

  return (
    <div className="w-full">
      <div className="border border-gray-300 bg-gray-50 rounded-lg p-4">
        <ProposalAttributes />
        {proposal.price != null && proposal.price > 0 && (
          <div className="flex items-center gap-6">
            <PriceProgressBar allocated={allocated} total={proposal.price} />
            <MarginIndicator planned={proposal.planned_margin} target={proposal.target_margin} />
          </div>
        )}
      </div>
    </div>
  );
}
